import styled from 'styled-components';
import InputMask, { type Props as InputMaskProps } from 'react-input-mask';

export const Input = styled.input`
  background: #ffffff;
  border: 1px solid #ced4da;
  border-radius: 8px;
  color: #212529;
  font-family: 'Open Sans', sans-serif;
  font-size: 1rem;
  padding: 0.9rem;
  width: 100%;
  transition: all 0.3s ease;

  &:focus {
    border-color: #049366;
    outline: none;
    box-shadow: 0 0 0 3px rgba(4, 147, 102, 0.1);
  }
`;

export const MaskedInput = styled(InputMask)<InputMaskProps>`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid rgba(145, 158, 171, 0.2);
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: all 0.15s;
  box-sizing: border-box;

  &:focus {
    border-color: ${(props) => props.color ?? '#16a34a'};;
  }

  &::placeholder {
    color: #9ca3af;
  }
`;
